// src/stone/illustrations/BoletoIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var BoletoIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 42 37",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#004033",
          d: "M42 5.669 38.307 37l-20.221-2.424-3.042-.364-.687-.083-.047-.005.114-.967.1-.837 1.826-15.5 1.558-13.221.094-.805 6.215.744z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M32.09 31.519a.1.1 0 0 1-.075.05l-15.23 2.848-.02.001h-.014l-1.72-.209a.113.113 0 0 1-.1-.122l.075-.873 1.232-16.57.995-13.373a.11.11 0 0 1 .065-.095l.608-.281a.1.1 0 0 1 .059-.01l6.837.71h.011l.027.007.012.005a.1.1 0 0 1 .028.02l.014.017.01.016.007.02.001.005 7.025 25.012a.114.114 0 0 1-.078.14l-.03.005a.11.11 0 0 1-.109-.083l-4.007-14.267 4.39 16.938a.11.11 0 0 1-.014.089"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#E8E9EA", d: "M23.588 0 0 5.3l6.806 30.798 23.588-5.3z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M4.759 10.541a.114.114 0 0 1-.024-.224l16.742-3.775a.114.114 0 0 1 .049.222L4.783 10.538zM17.221 12.654a.114.114 0 0 1-.024-.224l5.32-1.2c.06-.012.12.025.134.087a.114.114 0 0 1-.085.135l-5.32 1.2zM5.798 15.23a.114.114 0 0 1-.024-.224l8.09-1.825a.114.114 0 0 1 .049.222l-8.09 1.823zM17.794 15.239a.114.114 0 0 1-.024-.224l5.32-1.2c.06-.013.12.025.134.087a.113.113 0 0 1-.085.135l-5.32 1.2zM6.372 17.814a.114.114 0 0 1-.024-.224l8.09-1.824a.114.114 0 0 1 .049.222l-8.09 1.823zM14.724 27.791a.11.11 0 0 1-.11-.088l-.772-3.468a.113.113 0 0 1 .085-.136c.06-.013.121.025.135.086l.772 3.468a.114.114 0 0 1-.11.138M16.48 27.396a.11.11 0 0 1-.11-.089l-.772-3.468a.114.114 0 0 1 .085-.135c.06-.014.12.025.134.085l.772 3.468a.114.114 0 0 1-.11.139M18.236 27a.11.11 0 0 1-.11-.089l-.772-3.468a.114.114 0 0 1 .085-.135c.061-.013.121.025.134.086l.773 3.468a.114.114 0 0 1-.085.135zM19.991 26.604a.11.11 0 0 1-.11-.088l-.771-3.468a.114.114 0 0 1 .085-.136c.06-.013.12.025.134.086l.772 3.468a.113.113 0 0 1-.11.138M21.747 26.208a.11.11 0 0 1-.11-.088l-.771-3.468a.114.114 0 0 1 .084-.136c.061-.013.121.025.135.086l.772 3.468a.114.114 0 0 1-.11.138M23.503 25.812a.11.11 0 0 1-.11-.088l-.772-3.468a.114.114 0 0 1 .085-.136c.06-.013.12.025.134.086l.772 3.468a.113.113 0 0 1-.11.138M25.258 25.417a.11.11 0 0 1-.11-.088l-.771-3.468a.114.114 0 0 1 .085-.136c.06-.013.12.025.134.086l.772 3.468a.113.113 0 0 1-.11.138M10.538 29.061c-.586 0-1.115-.365-1.331-.785a.114.114 0 0 1 .048-.153.11.11 0 0 1 .152.048c.214.417.791.768 1.387.635.428-.096.76-.368.89-.729a.79.79 0 0 0-.109-.757c-.316-.412-.713-.433-1.215-.462l-.047-.002c-.541-.03-1.012-.09-1.292-.505a.98.98 0 0 1-.097-.925c.145-.369.49-.647.924-.744.433-.097.91.045 1.245.37a.114.114 0 0 1 .003.16.11.11 0 0 1-.159.003c-.22-.214-.61-.408-1.04-.311-.366.081-.645.302-.764.605a.76.76 0 0 0 .075.714c.223.33.62.378 1.119.406l.046.003c.537.03 1 .055 1.381.549.213.276.265.631.143.974-.156.434-.55.76-1.053.873a1.4 1.4 0 0 1-.306.033"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M10.898 29.519a.11.11 0 0 1-.11-.089L9.66 24.333a.112.112 0 1 1 .22-.05l1.128 5.098a.114.114 0 0 1-.11.138"
        }
      )
    ]
  }
);
var BoletoIllustration_default = BoletoIllustration;

export {
  BoletoIllustration_default
};
